import { useState } from "react";
// components
import DistrictList from "../Components/List/DistrictList";
import DivisitonList from "../Components/List/DivisitonList";
import UpazilaList from "../Components/List/UpazilaList";

// icon
import { MdCreateNewFolder } from "react-icons/md";
import { IoIosListBox } from "react-icons/io";

function RolePage(data) {
  const [view, setView] = useState(true);

  const [editId, setEditId] = useState(null);

  const viewHadler = (i) => {
    setView(i);
    setEditId(null);
  };

  const handleEdit = (id) => {
    setEditId(id);
    setView(false);
  };

  return (
    <div className="my-5 container-fluid">
      <div className="row">
        <div className="col-sm-6">
          <p className="f-18 text-primary pb-2 border-bottom border-primary">
            Country - Division - District - Sub-District
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <DivisitonList onEdit={handleEdit} />
        </div>
        <div className="col-sm-6">
          <DistrictList onEdit={handleEdit} />
        </div>
        <div className="col-sm-6">
          <UpazilaList onEdit={handleEdit} />
        </div>
      </div>
    </div>
  );
}

export default RolePage;
